(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["zg-same-type-strip"] && !Shopify.designMode) return;
  try {
    class ZgTypeStrip extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-zg-track]');
      this.nav = this.querySelector('[data-zg-nav]');
      this.prevBtn = this.querySelector('[data-zg-prev]');
      this.nextBtn = this.querySelector('[data-zg-next]');
      if (!this.track) return;

      this.onScroll = () => this.updateNav();
      this.onResize = () => this.updateNav();
      this.prevBtn?.addEventListener('click', () => this.scrollBy(-1));
      this.nextBtn?.addEventListener('click', () => this.scrollBy(1));
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });
      requestAnimationFrame(() => this.updateNav());
      this.hydrateSiblings();
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
    }

    scrollBy(direction) {
      if (!this.track) return;
      const amount = Math.max(this.track.clientWidth * 0.7, 120);
      this.track.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }

    updateNav() {
      if (!this.track || !this.nav) return;
      const overflow = this.track.scrollWidth > this.track.clientWidth + 2;
      this.nav.hidden = !overflow;
      if (!overflow) return;

      const max = this.track.scrollWidth - this.track.clientWidth - 1;
      if (this.prevBtn) this.prevBtn.disabled = this.track.scrollLeft <= 1;
      if (this.nextBtn) this.nextBtn.disabled = this.track.scrollLeft >= max;
    }

    async hydrateSiblings() {
      const currentHandle = this.dataset.zgHandle;
      const typeKey = (this.dataset.zgType || '').trim().toLowerCase();
      const collectionHandle = this.dataset.zgCollection;
      if (!currentHandle || !typeKey || !collectionHandle || !this.track) return;

      const existing = new Set();
      for (const link of this.track.querySelectorAll('a[href]')) {
        existing.add(this.productPath(link.getAttribute('href')));
      }

      const products = await this.fetchCatalog(collectionHandle);
      for (const product of products) {
        const productType = (product.product_type || '').trim().toLowerCase();
        if (productType !== typeKey || product.handle === currentHandle) continue;

        const path = `/products/${product.handle}`;
        if (existing.has(path)) continue;

        if (!this.isInStock(product)) continue;

        const item = document.createElement('a');
        item.className = 'zg-type-strip__item';
        item.href = path;
        item.setAttribute('aria-label', product.title || product.handle);
        item.setAttribute('role', 'listitem');

        const imageSrc =
          typeof product.featured_image === 'string'
            ? product.featured_image
            : product.featured_image?.src || product.images?.[0]?.src || '';

        if (imageSrc) {
          const image = document.createElement('img');
          image.className = 'zg-type-strip__img';
          image.src = imageSrc;
          image.alt = product.title || '';
          image.loading = 'lazy';
          image.width = 80;
          image.height = 80;
          item.appendChild(image);
        } else {
          const empty = document.createElement('span');
          empty.className = 'zg-type-strip__img zg-type-strip__img--empty';
          empty.setAttribute('aria-hidden', 'true');
          item.appendChild(empty);
        }

        this.track.appendChild(item);
        existing.add(path);
      }

      if (this.track.children.length > 0) {
        this.hidden = false;
      }

      this.updateNav();
    }

    isInStock(product) {
      if (product?.available === true) return true;
      if (product?.available === false) return false;

      const variants = Array.isArray(product?.variants) ? product.variants : [];
      return variants.some((variant) => variant?.available === true);
    }

    productPath(href) {
      try {
        return new URL(href, window.location.origin).pathname.replace(/\/$/, '') || href;
      } catch {
        return href;
      }
    }

    async fetchCatalog(handle) {
      const products = [];
      const limit = 250;

      try {
        for (let page = 1; page <= 8; page += 1) {
          const response = await fetch(
            `/collections/${encodeURIComponent(handle)}/products.json?limit=${limit}&page=${page}`
          );
          if (!response.ok) break;

          const data = await response.json();
          const pageProducts = Array.isArray(data.products) ? data.products : [];
          if (pageProducts.length === 0) break;

          products.push(...pageProducts);
          if (pageProducts.length < limit) break;
        }
      } catch (error) {
        console.error('Failed to load same-type products', error);
      }

      return products;
    }
  }

  if (!customElements.get('zg-type-strip')) {
    customElements.define('zg-type-strip', ZgTypeStrip);
  }
  } catch(e) { console.error(e); }
})();

})();
